import LandingLayoutRedesign from '../LandingPagesRedesign/LandingLayoutRedesign';

export default LandingLayoutRedesign;
